import {AxiosResponse} from "axios"
import addEtag from "./addEtag"
import removeAuthHeader from "../removeAuthHeader"

export default function (res: AxiosResponse) {
  removeAuthHeader(res.config)
  return addEtag(res)
}
